<template>
    <div class="info-box" >
        <h2 class="info-title" >
            We 
            <span class="spec" style="color:#00C969">All</span>    
            <span class="spec" style="color:#9300BB">Eat</span>
            Together
        </h2>
        <div class="title-desc" >
            <p>Taste the world with All Eat</p>
        </div>

        <div class="video-box" >
            <youtube class="youtube-video" height="630px" width="1120px" :video-id="videoCode" :player-vars="playerVars" ref="youtube" @playing="playing"></youtube>
        </div>
        
        <h2 class="info-title" style="margin-top: 80px;">
            What's <span class="font-new">new</span>
        </h2>

        <div class="pop-box" >
            <div class="pop-item" >
                <img :src="info.indexAppPhoto" alt="info">
            </div>
            <div class="pop-item">
                <img :src="info.indexApp2Photo" alt="info">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        videoCode: {
            type: String,
            default: ''
        },
        info: {
            type: Object,
            default: null
        }
    },
    computed: {
        player() {
            return this.$refs.youtube.player
        }
    },
    data() {
        return {
            // 播放器ide配置
            playerVars: {
                autoplay: 0
            }
        }
    },
    methods: {
        playVideo() {
            this.player.playVideo()
        },
        playing() {
            console.log('we are watching!!!')
        }
    }
}
</script>

<style scoped lang="scss">
    .info-box {
        min-height: 800px;
        background: #f5f5f5;
        padding-top: 50px;
        .info-title {
            text-align: center;
            color: #000000;
            margin: 0px 0px 17px 0px;
            font-family: "Roboto", Sans-serif;
            font-size: 36px;
            font-weight: 700;
            .spec {
                font-family: "Playfair Display", Sans-serif;
                font-style: italic;
                font-weight: normal;
            }

            .font-new {
                font-family: "Playfair Display", Sans-serif;
                color: #00C969;
                font-style: italic;
                transition: all .3s ease;
                font-weight: normal;

                &:hover {
                    color: #9300BB;
                }
            }
        }
        .title-desc {
            margin-top: 8px;
            text-align: center;
            color: #565656;
            font-family: "Roboto", Sans-serif;
            font-size: 21px;
            font-weight: 400;
            line-height: 26px;
        }

        .video-box {
            margin-top: 30px;
            display: flex;
            justify-content: center;
        }

        .pop-box {
            margin: 40px auto 0;
            width: 1140px;
            display: flex;
            padding-bottom: 120px;
            justify-content: space-around;
            .pop-item {
                margin: 20px;
                width: 570px;
                height: 340px;
                border-radius: 30px;
                overflow: hidden;

                img {
                    height: 100%;
                    width: 100%;
                }
            }
        }
    }
</style>